module.exports = __webpack_public_path__ + "static/kvitova-red-f7e2ebfb509aa9336e5e9e74d07e1b18.png";